import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const HomePage = () => import('../views/HomePage')
const AboutPage = () => import('../views/AboutPage')
const JoinPage = () => import('../views/JoinPage')


const router = new VueRouter({
  base: __dirname,
  routes: [{
    path: '/',
    component: HomePage
  }, {
    path: '/about',
    component: AboutPage
  }, {
    path: '/join',
    component: JoinPage
  }
  ]
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js